function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 402,
  width: 582,
  y: -1,
  x: -1
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
  y: 0.044297,
  fill: "#ffffff",
  x: 5.7,
  width: 4,
  id: "Top",
  height: 6
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#ffffff",
  y: 26,
  x: 5.7,
  width: 4,
  id: "Bottom",
  height: 6
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#ffffff",
  points: "5.7,27 9.7,31 9.7,27 ",
  id: "Shadow"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  id: "S",
  d: "m1.1,22.3c1.4,0.7 3.6,1.4 5.8,1.4c2.4,0 3.7,-1 3.7,-2.6c0,-1.4 -1.1,-2.3 -3.9,-3.2c-3.9,-1.4 -6.4,-3.5 -6.4,-6.9c0,-4 3.3,-7 8.8,-7c2.7,0 4.6,0.5 5.9,1.2l-1.2,4.2c-0.9,-0.5 -2.6,-1.1 -4.8,-1.1c-2.3,0 -3.4,1.1 -3.4,2.2c0,1.5 1.3,2.1 4.3,3.3c4.1,1.5 6,3.7 6,7c0,3.9 -3,7.2 -9.4,7.2c-2.7,0 -5.3,-0.7 -6.6,-1.4l1.2,-4.3z"
}));

var SvgDollarIcon = function SvgDollarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.9,
    height: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollarIcon.9950b90a.svg";
export { ForwardRef as ReactComponent };